export default "__VITE_ASSET__B69VNF9J__"